import { createFileRoute } from "@tanstack/react-router";
import { GaragePrices } from "@/features/settings/garage-settings";

export const Route = createFileRoute("/settings/prices")({
  component: GaragePrices,
});
